module.exports = __webpack_public_path__ + "static/media/ic_close.05bb717e.svg";